import imageCompression from 'browser-image-compression';
import axios from 'axios';
import { getImagePath } from '../../../../../common/productImageUtils';

const imageCompressionHandler = async ({ fileData }) => {
	return imageCompression(fileData, {
		maxSizeMB: 3,
		// maxWidthOrHeight: 1920,
		useWebWorker: true,
		maxIteration: 15,
		onProgress: prog => {}
	});
};

export const getRandomColor = (noImage, colorToSkip = '') => {
	let noImageStyle = {};

	if (noImage) {
		const backgroundColor = [
			'FCF4FF',
			'FDF9F1',
			'F6F7FD',
			'EEFAF7',
			'FFEFF9',
			'EAFAFF',
			'FFF4F4'
		];
		const randomNum = Math.floor(Math.random() * (7 - 0)) + 0; //The maximum is exclusive and the minimum is inclusive
		const color = '#' + backgroundColor[randomNum];
		if (color == colorToSkip) {
			return getRandomColor(noImage, colorToSkip);
		}
		return (noImageStyle = {
			background: '#' + backgroundColor[randomNum]
		});
	} else {
		return noImageStyle;
	}
};

let fileCount = 0;
export const generateFileId = () => {
	return (
		Math.random()
			.toString()
			.substring(2, 6) + fileCount++
	);
};

const uploadSingleFile = async ({ cb, file, randomId, key }) => {
	const formData = new FormData();
	formData.append('uploadedImageFile', file);
	let url = `/marketplace/static/php/jdCourier/uploadImages.php`;
	axios.post(url, formData).then(({ data }) => {
		if (data.msg == 'File uploaded') {
			const fileType = data.imgURL
				.split('.')
				.pop()
				.toLowerCase();
			const cbData = {
				id: randomId,
				finalUrl: getImagePath(data.imgURL, null, 'jdCourier'),
				uploaded: true,
				success: true,
				fileType,
				key
			};
			cb(cbData);
		} else {
			const cbData = {
				success: false,
				key
			};
			cb(cbData);
		}
	});
};

export const uploadMultipleFiles = ({ files: fileList, cb }) => {
	for (let key in fileList) {
		if (!fileList.hasOwnProperty(key)) {
			continue;
		}
		const fileData = fileList[key];
		const randomId = generateFileId();
		let originalFile = new File([fileData], fileData.name);
		const fileType = fileData.name
			.split('.')
			.pop()
			.toLowerCase();
		imageCompressionHandler({ fileData }).then(compressedFile => {
			console.log(
				`compressedFile size ${compressedFile.size / 1024 / 1024} MB`
			);
			compressedFile = new File([compressedFile], fileData.name); //required for file upload service
			imageCompression
				.getDataUrlFromFile(compressedFile)
				.then(base64Url => {
					const cbData = {
						id: randomId,
						url: base64Url,
						uploaded: false,
						fileType,
						success: true,
						key: fileData.key
					};
					cb(cbData);
				});
			uploadSingleFile({
				cb,
				file: originalFile,
				key: fileData.key,
				randomId
			});
		});
	}
};
